import Box from '@mui/material/Box';

function PageContainer({ children, sx }) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 1400,
        mx: 'auto',
        px: { xs: 2, sm: 3, md: 4 },
        py: 3,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default PageContainer;
